"use client";

import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function TopCounselingListSection() {
  const swiperRef = useRef(null);

  const popularCountries = [
    {
      title: "MBBS in Georgia",
      image: "/assets/img/ug_abroad/Mbbs_Georgia.jpg",
      href: "/mbbs-in-georgia",
    },
    {
      title: "MBBS in Russia",
      image: "/assets/img/ug_abroad/Mbbs_Russia.png",
      href: "/mbbs-in-russia",
    },
    {
      title: "MBBS in Uzbekistan",
      image: "/assets/img/ug_abroad/Mbbs_uzbekistan.png",
      href: "/mbbs-in-uzbekistan",
    },
    {
      title: "MBBS in Malaysia",
      image: "/assets/img/ug_abroad/Mbbs_malaysia.png",
      href: "/mbbs-in-malaysia",
    },
    {
      title: "MBBS in Nepal",
      image: "/assets/img/ug_abroad/Mbbs_Nepal.png",
      href: "/mbbs-in-nepal",
    },
    {
      title: "MBBS in India",
      image: "/assets/img/ug_abroad/Mbbs_India.png",
      href: "/mbbs-in-india",
    },
    {
      title: "MBBS in China",
      image: "/assets/img/ug_abroad/china.webp",
      href: "/mbbs-in-china",
    },
    {
      title: "MBBS in NewZealand",
      image: "/assets/img/ug_abroad/Newzeland.webp",
      href: "/mbbs-in-new-zealand",
    },
    {
      title: "MBBS in USA",
      image: "/assets/img/ug_abroad/USA.webp",
      href: "/mbbs-in-united-states",
    },
    {
      title: "MBBS in UK",
      image: "/assets/img/ug_abroad/UK.webp",
      href: "/mbbs-in-united-kingdom",
    },
    {
      title: "MBBS in Japan",
      image: "/assets/img/ug_abroad/Japan.webp",
      href: "/mbbs-in-japan",
    },
    {
      title: "MBBS in Australia",
      image: "/assets/img/ug_abroad/Australia.webp",
      href: "/mbbs-in-australia",
    },
    {
      title: "MBBS in Germany",
      image: "/assets/img/ug_abroad/Germany.webp",
      href: "/mbbs-in-germany",
    },

  ];

  return (
    <section className="top-counseling-section">
      <style>{`
        .top-counseling-section {
          max-width: 1600px;
          margin: 0 auto;
          padding: 25px 24px 0px;
          overflow: hidden;
        }

        .top-counseling-heading {
          max-width: 950px;
          margin: 0 auto 42px;
          text-align: center;
        }

        .top-counseling-heading h2 {
          margin: 0;
          font-size: 2.35rem;
          line-height: 1.2;
          font-weight: 900;
          letter-spacing: -0.03em;
          color: #0f172a;
        }

        .top-counseling-heading h2 span {
          color: #ff9245;
        }

        .top-counseling-heading p {
          margin: 12px 0 0;
          font-size: 1.08rem;
          line-height: 1.6;
          font-weight: 500;
          color: #334155;
        }

        .top-counseling-swiper-wrapper {
          position: relative;
          width: 100%;
          padding: 4px 0 50px;
        }

        .top-counseling-swiper-layout {
          position: relative;
          display: grid;
          grid-template-columns: 52px minmax(0, 1fr) 52px;
          align-items: center;
          gap: 18px;
        }

        .top-counseling-swiper {
          width: 100%;
          padding: 10px 0 52px;
        }

        .top-counseling-swiper .swiper-wrapper {
          align-items: stretch;
        }

        .top-counseling-swiper .swiper-slide {
          height: auto;
          display: flex;
          align-items: center;
        }

        .popular-card {
          position: relative;
          display: block;
          width: 100%;
          overflow: visible;
          border-radius: 32px;
          border: none;
          background: transparent;
          box-shadow: none;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .popular-card:hover {
          transform: translateY(-5px);
        }

        .popular-img-wrap {
          position: relative;
          width: 100%;
          overflow: hidden;
          border-radius: 32px;
          background: transparent;
          box-shadow: 0 14px 34px rgba(255, 146, 69, 0.12);
        }

        .popular-img {
          width: 100%;
          height: auto;
          display: block;
          object-fit: contain;
          object-position: center;
          background: transparent;
          transition: transform 0.4s ease;
        }

        .popular-card:hover .popular-img {
          transform: scale(1.02);
        }

        .popular-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: flex-end;
          background: transparent;
          pointer-events: none;
          z-index: 2;
        }

        .popular-content {
          width: 100%;
          padding: 0 30px 28px;
          color: #ffffff;
        }

        .popular-title {
          margin: 0 0 14px;
          font-size: 1.48rem;
          line-height: 1.25;
          font-weight: 900;
          color: #ffffff;
          text-shadow: 0 3px 12px rgba(0, 0, 0, 0.85);
        }

        .popular-explore {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 999px;
          background: #ff9245;
          color: #ffffff;
          padding: 11px 24px;
          font-size: 0.96rem;
          font-weight: 800;
          line-height: 1;
          transition: all 0.3s ease;
          pointer-events: auto;
          box-shadow: 0 8px 20px rgba(255, 146, 69, 0.28);
        }

        .popular-card:hover .popular-explore {
          background: #f47f2e;
          transform: translateY(-1px);
          box-shadow: 0 10px 24px rgba(255, 146, 69, 0.38);
        }

        .top-counseling-swiper-nav {
          width: 52px;
          height: 52px;
          border-radius: 999px;
          background: #ff9245;
          color: #ffffff;
          box-shadow: 0 10px 26px rgba(255, 146, 69, 0.34);
          z-index: 3;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 0;
          flex: 0 0 auto;
          transition: all 0.25s ease;
        }

        .top-counseling-swiper-nav:hover {
          background: #f47f2e;
          transform: scale(1.06);
        }

        .top-counseling-swiper-nav span {
          font-size: 24px;
          font-weight: 900;
          line-height: 1;
        }

        .top-counseling-swiper .swiper-pagination {
          bottom: 0 !important;
        }

        .top-counseling-swiper .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #e5e7eb;
          opacity: 1;
          transition: all 0.25s ease;
        }

        .top-counseling-swiper .swiper-pagination-bullet-active {
          width: 30px;
          border-radius: 999px;
          background: #ff9245;
        }

        @media (max-width: 1280px) {
          .top-counseling-section {
            max-width: 1380px;
            padding-left: 22px;
            padding-right: 22px;
          }

          .popular-card {
            border-radius: 30px;
          }

          .popular-img-wrap {
            border-radius: 30px;
          }

          .top-counseling-swiper-layout {
            grid-template-columns: 48px minmax(0, 1fr) 48px;
            gap: 16px;
          }

          .top-counseling-swiper-nav {
            width: 48px;
            height: 48px;
          }
        }

        @media (max-width: 1024px) {
          .top-counseling-section {
            padding: 56px 18px 72px;
          }

          .top-counseling-swiper-wrapper {
            padding: 4px 0 46px;
          }

          .top-counseling-swiper-layout {
            grid-template-columns: 44px minmax(0, 1fr) 44px;
            gap: 14px;
          }

          .top-counseling-heading h2 {
            font-size: 2rem;
          }

          .popular-card {
            border-radius: 28px;
          }

          .popular-img-wrap {
            border-radius: 28px;
          }

          .popular-content {
            padding: 0 24px 26px;
          }

          .top-counseling-swiper-nav {
            width: 44px;
            height: 44px;
          }
        }

        @media (max-width: 767px) {
          .top-counseling-section {
            padding: 44px 16px 58px;
          }

          .top-counseling-heading {
            margin-bottom: 28px;
          }

          .top-counseling-heading h2 {
            font-size: 1.65rem;
          }

          .top-counseling-heading p {
            font-size: 0.96rem;
          }

          .top-counseling-swiper-wrapper {
            padding: 0 0 42px;
          }

          .top-counseling-swiper-layout {
            display: block;
          }

          .top-counseling-swiper {
            padding: 6px 0 42px;
          }

          .top-counseling-swiper-nav {
            display: none;
          }

          .popular-card {
            border-radius: 26px;
          }

          .popular-img-wrap {
            border-radius: 26px;
          }

          .popular-content {
            padding: 0 22px 24px;
          }

          .popular-title {
            font-size: 1.22rem;
          }

          .popular-explore {
            padding: 10px 20px;
            font-size: 0.88rem;
          }
        }

        @media (max-width: 480px) {
          .top-counseling-section {
            padding-left: 14px;
            padding-right: 14px;
          }

          .top-counseling-heading h2 {
            font-size: 1.45rem;
          }

          .top-counseling-heading p {
            font-size: 0.9rem;
          }

          .popular-card {
            border-radius: 22px;
          }

          .popular-img-wrap {
            border-radius: 22px;
          }

          .popular-content {
            padding: 0 18px 20px;
          }

          .popular-title {
            font-size: 1.12rem;
            margin-bottom: 12px;
          }

          .popular-explore {
            padding: 9px 17px;
            font-size: 0.84rem;
          }
        }

        @media (max-width: 360px) {
          .popular-card {
            border-radius: 20px;
          }

          .popular-img-wrap {
            border-radius: 20px;
          }
        }
      `}</style>

      <div className="top-counseling-heading">
        <h2>
          Most Popular <span>Countries for MBBS</span>
        </h2>

        <p>
          With NeetSupport you can get MBBS Admission in renowned Medical
          Universities Worldwide
        </p>
      </div>

      <div className="top-counseling-swiper-wrapper">
        <div className="top-counseling-swiper-layout">
          <button
            type="button"
            className="top-counseling-swiper-nav top-counseling-swiper-nav-prev"
            aria-label="Previous slide"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <span>‹</span>
          </button>

          <Swiper
            modules={[Pagination, Autoplay]}
            className="top-counseling-swiper"
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            slidesPerView={3}
            slidesPerGroup={1}
            spaceBetween={28}
            loop={popularCountries.length > 3}
            speed={700}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 18,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1280: {
                slidesPerView: 3,
                spaceBetween: 28,
              },
            }}
          >
            {popularCountries.map((item) => (
              <SwiperSlide key={item.title}>
                <a href={item.href} className="popular-card">
                  <div className="popular-img-wrap">
                    <img
                      src={item.image}
                      alt={item.title}
                      loading="lazy"
                      className="popular-img"
                    />

                    <div className="popular-overlay">
                      <div className="popular-content">
                        {/* <h3 className="popular-title">{item.title}</h3> */}
                        <span className="popular-explore">Explore →</span>
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            type="button"
            className="top-counseling-swiper-nav top-counseling-swiper-nav-next"
            aria-label="Next slide"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <span>›</span>
          </button>
        </div>
      </div>
    </section>
  );
}